module.exports = __webpack_public_path__ + "static/media/p4.cdf002b6.png";